import { routes } from "routes";
import { IShortUser } from "services/types";
import { useNewVerifiedCreators } from "queries";
import { UserListWidgetAlive } from "components/widgets/UserListWidgetAlive";

import { IUserInfo } from "./types";

export const NewCreators = (): JSX.Element => {
  const creators = useNewVerifiedCreators();

  if (creators.isError) {
    return <p>Error loading creators.</p>;
  }

  if (!creators.isSuccess || !creators.data || creators.data.creators.length === 0) {
    return <></>;
  }

  const items = creators.data.creators.map((el: IShortUser): IUserInfo => ({
    id: el.username,
    name: el.name ?? el.username,
    image: el.profileImageUrl ?? undefined,
    following: false,
    verified: el.verified,
  }));

  return (
    <UserListWidgetAlive
      className="newCreators"
      title="🎉 Newly Verified Creators"
      link={routes.exploreCreators("recent", true)}
      items={items}
      list={true}
    />
  );
};
